export const RedoIcon = ({ isActive }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";

  return (
    <svg width="24" height="24" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6006 0.180664C11.8422 -0.0605657 12.2418 -0.0605223 12.4834 0.180664L14.6172 2.31445C14.8588 2.55613 14.8588 2.9566 14.6172 3.19824L12.4834 5.33105C12.3584 5.45596 12.2003 5.51465 12.042 5.51465C11.8837 5.51463 11.7256 5.45598 11.6006 5.33105C11.359 5.08944 11.3591 4.68992 11.6006 4.44824L12.6172 3.43066H4.79199C2.84206 3.4307 1.25006 5.02273 1.25 6.97266C1.25 8.92263 2.84202 10.5146 4.79199 10.5146H11.459C11.8005 10.5148 12.084 10.7981 12.084 11.1396C12.0839 11.4811 11.8088 11.7645 11.459 11.7646H4.79199C2.15036 11.7646 0 9.6143 0 6.97266C5.60083e-05 4.33106 2.15039 2.1807 4.79199 2.18066H12.7168L11.6006 1.06445C11.3589 0.822786 11.3589 0.422331 11.6006 0.180664Z"
        fill={finalColor}
      />
    </svg>
  );
};
